// Angular
import type { IsActiveMatchOptions } from '@angular/router';

// App
import { SidebarMenuGroupVM } from '@app/core/types/sidebar-menu-group.interface';

const SUBSET_ACTIVE_MATCH: IsActiveMatchOptions = {
  paths: 'subset',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

export const STATIC_SIDEBAR_MENU: SidebarMenuGroupVM[] = [
  {
    id: 'messages',
    title: 'پیامک‌ها',
    canView: true,
    items: [
      { id: 'messages.send', label: 'ارسال پیامک', icon: 'ic-messages-plain-3', routerLink: '/messages/send', canView: true },
      {
        id: 'messages.reports',
        label: 'گزارش‌ها',
        icon: 'ic-time-history',
        routerLink: '/messages/reports',
        routerLinkOptions: SUBSET_ACTIVE_MATCH,
        canView: true,
      },
      { id: 'messages.contacts-events', label: 'مخاطبان و رویدادها', icon: 'ic-users-users-group-rounded', routerLink: '/messages/contacts-events', canView: true },
      { id: 'messages.drafts', label: 'پیش‌نویس و متغیرها', icon: 'ic-notes-clipboard', routerLink: '/messages/drafts', canView: true },
    ],
  },

  {
    id: 'developers',
    title: 'برنامه نویسان',
    canView: true,
    items: [
      { id: 'developers.api-keys', label: 'لیست کلیدهای API', icon: 'ic-network-code-2', routerLink: '/developers/api-keys', canView: true },
      { id: 'developers.template-send', label: 'ارسال با قالب', icon: 'ic-notes-notes', routerLink: '/developers/template-send', canView: true },
      { id: 'developers.api-errors', label: 'خطاهای فراخوانی API', icon: 'ic-network-bug', routerLink: '/developers/api-errors', canView: true },
      { id: 'developers.docs', label: 'مستندات و افزونه‌ها', icon: 'ic-school-book-2', routerLink: '/developers/docs', canView: true },
    ],
  },

  {
    id: 'sms-tools',
    title: 'ابزارهای پیامکی',
    canView: true,
    items: [
      { id: 'sms-tools.secretary', label: 'منشی پیامکی', icon: 'ic-messages-chat-square-code', routerLink: '/sms-tools/secretary', canView: true },
      { id: 'sms-tools.transfer', label: 'انتقال پیامک', icon: 'ic-arrows-action-forward', routerLink: '/sms-tools/transfer', canView: true },
      { id: 'sms-tools.code-reader', label: 'کد خوان', icon: 'ic-security-code-scan', routerLink: '/sms-tools/code-reader', canView: true },
      { id: 'sms-tools.blacklist', label: 'لیست سیاه', icon: 'ic-security-shield-cross', routerLink: '/sms-tools/blacklist', routerLinkOptions: SUBSET_ACTIVE_MATCH, canView: true },
    ],
  },

  {
    id: 'billing',
    title: 'مالی و پلن‌ها',
    canView: true,
    items: [
      { id: 'billing.plans', label: 'پلن‌ها', icon: 'ic-design-layers-minimalistic', routerLink: '/billing/plans', canView: true },
      { id: 'billing.top-up', label: 'خرید شارژ', icon: 'ic-money-wallet-2', routerLink: '/billing/top-up', canView: true },
      { id: 'billing.transactions', label: 'تراکنش‌ها و فاکتور', icon: 'ic-money-bill-list', routerLink: '/billing/transactions', canView: true },
    ],
  },

  {
    id: 'numbers',
    title: 'شماره‌های پیامکی',
    canView: true,
    items: [
      { id: 'numbers.manage', label: 'مدیریت شماره‌ها', icon: 'ic-call-phone', routerLink: '/numbers/manage', canView: true },
    ],
  },

  {
    id: 'payamak-sefid',
    title: 'پیامک سفید',
    canView: true,
    items: [
      { id: 'payamak-sefid.app-download', label: 'دانلود اپلیکیشن', icon: 'ic-arrows-action-download', routerLink: '/payamak-sefid/app-download', canView: true },
      { id: 'payamak-sefid.apps', label: 'مدیریت اپلیکیشن‌ها', icon: 'ic-design-three-squares', routerLink: '/payamak-sefid/apps', canView: true },
      { id: 'payamak-sefid.contacts', label: 'مخاطبان پیامک سفید', icon: 'ic-users-users-group-two-rounded', routerLink: '/payamak-sefid/contacts', canView: true },
      { id: 'payamak-sefid.memberships', label: 'پیامک‌های عضویت', icon: 'ic-messages-chat-round-check', routerLink: '/payamak-sefid/memberships', canView: true },
    ],
  },

  {
    id: 'support',
    title: 'پشتیبانی',
    canView: true,
    items: [
      { id: 'support.tickets', label: 'تیکت‌ها و پشتیبانی', icon: 'ic-messages-chat-line', routerLink: '/support/tickets', canView: true },
      // { id: 'support.faq', label: 'سوالات متداول', icon: 'ic-ui-essentional-question-circle', routerLink: '/support/faq', canView: true },
    ],
  },

  {
    id: 'profile',
    title: 'پروفایل',
    canView: true,
    items: [
      { id: 'profile.settings', label: 'تنظیمات پروفایل', icon: 'ic-users-user', routerLink: '/profile/settings', canView: true },
      // { id: 'profile.affiliate', label: 'همکاری در فروش', icon: 'ic-hands-hand-money', routerLink: '/profile/affiliate', canView: true },
    ],
  },
];
